import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6 6h24v18H7.755L6 25.755V6zm0-3a2.996 2.996 0 00-2.985 3L3 33l6-6h21c1.65 0 3-1.35 3-3V6c0-1.65-1.35-3-3-3H6zm3 15h12v3H9v-3zm0-4.5h18v3H9v-3zM9 9h18v3H9V9z" fill="#e7ebed" /></svg>);